// frontend/src/DanisanEkle.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Button, Card, Alert, Spinner, Col, Row } from 'react-bootstrap';
import api from './api';

function DanisanEkle({ theme }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    ad: '', soyad: '', eposta: '', telefon: '',
    hedef_kilo: '', notlar: '',
    paket_adi: '', toplam_seans: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/diyetisyen/danisanlar', formData);
      setTimeout(() => navigate('/danisanlar'), 1000);
    } catch (err) {
      setError(err.response?.data?.mesaj || 'Danışan eklenirken bir hata oluştu.');
      setLoading(false);
    }
  };

  return (
    <div>
      <Link to="/danisanlar" className="btn btn-sm d-inline-flex align-items-center gap-2 mb-4" style={{ color: 'var(--text-muted)', border: '1px solid var(--border-color)', backgroundColor: 'transparent' }}>
        <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>arrow_back</span> Danışan Listesi
      </Link>
      <Card className="glass-card" style={{ color: 'var(--text-main)' }}>
        <Card.Header as="h2" style={{ color: 'var(--text-main)' }}>Yeni Danışan Ekle</Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            {/* Kişisel Bilgiler */}
            <h5 className="mb-3 fw-bold" style={{ color: 'var(--accent-primary)' }}>
              <span className="material-symbols-outlined me-2" style={{ fontSize: '20px', verticalAlign: 'middle' }}>person</span>
              Kişisel Bilgiler
            </h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Ad</Form.Label>
                  <Form.Control type="text" name="ad" value={formData.ad} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Soyad</Form.Label>
                  <Form.Control type="text" name="soyad" value={formData.soyad} onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control type="email" name="eposta" value={formData.eposta} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control type="tel" name="telefon" value={formData.telefon} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Hedef Kilo (kg)</Form.Label>
              <Form.Control type="number" name="hedef_kilo" value={formData.hedef_kilo} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Genel Notlar</Form.Label>
              <Form.Control as="textarea" rows={3} name="notlar" value={formData.notlar} onChange={handleChange} />
            </Form.Group>

            {/* Paket & Seans Bilgileri */}
            <hr style={{ borderColor: 'var(--border-color)' }} />
            <h5 className="mb-3 fw-bold" style={{ color: 'var(--accent-tertiary)' }}>
              <span className="material-symbols-outlined me-2" style={{ fontSize: '20px', verticalAlign: 'middle' }}>inventory_2</span>
              Paket & Seans Bilgileri
            </h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Paket Adı</Form.Label>
                  <Form.Control type="text" name="paket_adi" value={formData.paket_adi} onChange={handleChange} placeholder="Örn: 3 Aylık Standart Paket" />
                  <Form.Text style={{ color: 'var(--text-muted)' }}>Danışana atanacak paketin ismini yazın.</Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Toplam Seans Sayısı</Form.Label>
                  <Form.Control type="number" min="0" name="toplam_seans" value={formData.toplam_seans} onChange={handleChange} placeholder="Örn: 12" />
                  <Form.Text style={{ color: 'var(--text-muted)' }}>Her randevu 1 seans olarak sayılır.</Form.Text>
                </Form.Group>
              </Col>
            </Row>

            {error && <Alert variant="danger">{error}</Alert>}

            <div className="d-grid mt-3">
              <Button type="submit" variant="primary" disabled={loading} className="fw-bold py-2">
                {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Danışanı Kaydet'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default DanisanEkle;